<template>
  <div class="award_wrap" >
    <div class="award_content" >
      <img :src="awardVo.luckDrawGoodsPicUrl" />
      <div class="award_right" >
        <div>
          <div class="award_title" >{{ awardVo.luckDrawGoodsName }}</div>
<!--          <div class="winner_value" >价值<span>1999</span></div>-->
        </div>
        <div class="award_date" >中奖日期：{{ awardVo.createTime }}</div>
      </div>
    </div>

    <van-form @submit="onSubmit">
      <div class="receive_wrap" >
        <div class="receive_title" >收件人信息</div>
        <div class="receive_item" >
          <div>姓名：</div>
          <van-field placeholder="请填写收件人姓名" class="receive_input" v-model="addressName" name="addressName"
                     :rules="[{ required: true, message: '' }]"/>
        </div>
        <div class="receive_item" >
          <div>电话：</div>
          <van-field placeholder="请填写收件人电话" class="receive_input" v-model="phone" type="number" :maxlength="11" name="phone"
                     :rules="[{ required: true, message: '' }]"/>
        </div>
  <!--      <div class="receive_item" >
          <div>地址：</div>
          <van-field placeholder="省/市/区" class="receive_input" readonly />
        </div>-->
        <div class="receive_item" >
          <div>详细地址：</div>
          <van-field placeholder="请填写详细地址" type="textarea" :rows="2" class="receive_input" v-model="address" name="address"
                     :rules="[{ required: true, message: '' }]"/>
        </div>
      </div>

      <van-button class="confirm_btn"  native-type="submit" :loading="submitting" >确认领取</van-button>
    </van-form>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import {
  updateLuckDrawGoodsOrderAddress
} from '@/api/luckdraw'
import { Toast } from 'vant'
export default {
  name: 'receiveAward',
  data() {
    return {
      awardVo: JSON.parse(localStorage.getItem('awardVo')),
      address: '',
      addressName: '',
      phone: '',
      submitting: false
    }
  },
  methods: {
    onSubmit(values) {
      const { luckDrawGoodsOrderId } = this.awardVo
      values.luckDrawGoodsOrderId = luckDrawGoodsOrderId
      this.submitting = true
      console.log({...values})
      updateLuckDrawGoodsOrderAddress({...values}).then(res => {
        this.submitting = false
        if(res.success) {
          Toast('领取成功')
          this.$router.go(-1)
        }else {
          Toast(res.msg)
        }
      })
    }
  },
  mounted() {
    console.log({...this.awardVo})
  }
}
</script>
